//------------- COMPONENT INPUT SEARCH BOX ---------

//importações
import React, { useEffect } from "react";
import "./styles.css";

//icons
import { BsSearch } from "react-icons/bs";

//component
//size muda o estilo do tamanho da barra de pesquisa
const InputSearch = ({ search, setSearch, size, placeholder = "pesquisa...", handleSearch }) => {
    //view do component
    useEffect(() => {
        handleSearch()
    }, [search])

    return (
        <div className={size === "full" ? "search-div-full" : "search-div"}>
            <input
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleSearch();
                        e.preventDefault()
                        return false;
                    }
                }}
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    handleSearch();
                }}
                className="search-input"
                type="text"
                placeholder={placeholder}
            ></input>
            <div
                className="btn-icon"
                onClick={() => {
                    handleSearch();
                }}
            >
                <BsSearch className="icon-search"></BsSearch>
            </div>
        </div>
    );
};

export default InputSearch;
